import { useEffect } from 'react';

//components
import { Grad } from '@/containers-ai/SectionHeading';
import { setHubspotFormIntegration } from '@/containers-m/HubspotFormSimplified/HubspotFormSimplifiedV4';

//assets
import { DisclaimerText } from '@/vendor/HubspotFormIntegration';

//styles
import {
  FormSection,
  FormInner,
  FormCopy,
  FormTitle,
  FormSubtitle,
  FormFieldsWrap,
  HubspotFormContainer,
  DisclaimerWrapper,
} from './GetInTouch.styles';

export function GetInTouch({
  title,
  subtitle,
  portalId,
  formId,
  target = 'integration-hubspot',
  region,
  disclaimer = false,
}) {
  useEffect(() => {
    setHubspotFormIntegration();
  }, []);

  return (
    <FormSection id={target}>
      <FormInner>
        <FormCopy>
          <FormTitle>
            <Grad>{title}</Grad>
          </FormTitle>
          <FormSubtitle>{subtitle}</FormSubtitle>
        </FormCopy>
        <FormFieldsWrap>
          <HubspotFormContainer>
            <div
              className="hs-form-html"
              data-region={region}
              data-form-id={formId}
              data-portal-id={portalId}
            ></div>

            {disclaimer && (
              <DisclaimerWrapper>
                <DisclaimerText />
              </DisclaimerWrapper>
            )}
          </HubspotFormContainer>
        </FormFieldsWrap>
      </FormInner>
    </FormSection>
  );
}
